import React, { useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useHandleclickOutside from "../../hooks/useHandleclickOutside";
import { logout } from "../../Redux/authSlice";
import { removeToken } from "../Avatar/Utility";
import LogoutModal from "./LogoutModal";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const Header = () => {
  const dealershipTheme = useTheme();
  const user = JSON.parse(localStorage.getItem("user"));
  const theme = user?.role === "DealershipAdmin" ? dealershipTheme : "#3b82f6"; // primary blue for admin

  const profileref = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useHandleclickOutside(profileref, () => setIsDropdownOpen(false));

  const location = useLocation();
  const currentPath =
    location.pathname
      .split("/")
      .filter((path) => path)
      .pop() || "Home";

  const formattedPath = currentPath
    .replace(/[-_]/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleLogoutClick = () => {
    setModalVisible(true);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("user");
    dispatch(logout());
    removeToken();
    navigate("/login");
  };

  return (
    <header className="relative z-50 flex justify-between items-center bg-white/80 backdrop-blur-lg border-b border-blue-200/50 px-6 py-2 rounded-xl shadow-lg  w-full ">
      <div className="flex flex-col">
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 flex items-center gap-2">
          Dashboard <span className="text-slate-500 font-light">/</span> <span style={{ color: theme }}>{formattedPath}</span>
        </h2>
        <p className="text-sm text-slate-600 mt-1 hidden md:block">
          Welcome back, <span className="text-slate-800 font-medium">{user?.email?.split("@")[0].charAt(0).toUpperCase() + user?.email?.split("@")[0].slice(1)}</span>!
        </p>
      </div>

      <div className="relative flex items-center gap-4 cursor-pointer hover:bg-slate-700/30 p-2 rounded-xl transition-all duration-300" ref={profileref} onClick={toggleDropdown}>
        <div className="relative flex items-center justify-center w-10 h-10 rounded-full shadow-lg overflow-hidden border-2" style={{ borderColor: theme, backgroundColor: theme + '33' }}>
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-slate-800" viewBox="0 -960 960 960" fill="currentColor"><path d="M480-480.67q-66 0-109.67-43.66Q326.67-568 326.67-634t43.66-109.67Q414-787.33 480-787.33t109.67 43.66Q633.33-700 633.33-634t-43.66 109.67Q546-480.67 480-480.67ZM160-160v-100q0-36.67 18.5-64.17T226.67-366q65.33-30.33 127.66-45.5 62.34-15.17 125.67-15.17t125.33 15.5q62 15.5 127.28 45.3 30.54 14.42 48.96 41.81Q800-296.67 800-260v100H160Zm66.67-66.67h506.66V-260q0-14.33-8.16-27-8.17-12.67-20.5-19-60.67-29.67-114.34-41.83Q536.67-360 480-360t-111 12.17Q314.67-335.67 254.67-306q-12.34 6.33-20.17 19-7.83 12.67-7.83 27v33.33ZM480-547.33q37 0 61.83-24.84Q566.67-597 566.67-634t-24.84-61.83Q517-720.67 480-720.67t-61.83 24.84Q393.33-671 393.33-634t24.84 61.83Q443-547.33 480-547.33Zm0-86.67Zm0 407.33Z" /></svg>
          <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></span>
        </div>

        <div className="hidden md:flex flex-col">
          <p className="text-sm font-semibold text-slate-900">{user?.email?.split("@")[0].charAt(0).toUpperCase() + user?.email?.split("@")[0].slice(1)}</p>
          <p className="text-xs text-slate-600" style={{ color: theme }}>{user?.role}</p>
        </div>

        <div className="text-slate-600">
          <FaChevronDown className={`transition-transform duration-300 ${isDropdownOpen ? 'rotate-180' : ''}`} />
        </div>

        {isDropdownOpen && (
          <div className="absolute top-14 right-0 w-48 bg-white border border-blue-200/50 rounded-xl shadow-md overflow-hidden z-[99999] animate-fade-in-up">
            <ul className="flex flex-col w-full text-sm text-slate-800 font-medium">
              <li className="px-4 py-3 hover:bg-slate-700/50 cursor-pointer transition-colors" onClick={() => navigate("/profile")}>
                Profile
              </li>
              <li className="px-4 py-3 hover:bg-red-500/20 hover:text-red-400 cursor-pointer transition-colors border-t border-blue-200/30" onClick={handleLogoutClick}>
                Logout
              </li>
            </ul>
          </div>
        )}
      </div>

      <LogoutModal
        isVisible={isModalVisible}
        onCancel={() => setModalVisible(false)}
        onConfirm={handleConfirmLogout}
      />
    </header>
  );
};

export default Header;
